import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GiCrossedBones } from 'react-icons/gi';
import { LuSave } from 'react-icons/lu';
import ZoneGrid from "../HealthProduct/components/zoneGrid";
import PlanGrid from "../HealthProduct/components/planGrid";

import { saveZone, savePlan, submitHealthProduct } from "../../../services/apiService";
import InsurerDropdown from "../../../utils/Insurer";

const HealthProductMaster = () => {
  const [zones, setZones] = useState([]);
  const [plans, setPlans] = useState([]);
  const [isZoneEnabled, setIsZoneEnabled] = useState(false);
  const [isPlanEnabled, setIsPlanEnabled] = useState(false);
  const [selectedYears, setSelectedYears] = useState(1);

  // Form Validation Schema
  const validationSchema = Yup.object({
    // insurer: Yup.string().required("Insurer is required"),
    productName: Yup.string().required("Product Name is required"),
    productShortName: Yup.string().required("Product Short Name is required"),
  });

  const generateRandomNumber = () => {
    return Math.floor(Math.random() * 90) + 10; // Generates a number between 10 and 99
  };

  // Save Zone
  const handleZoneSave = async (zone) => {
    try {
      // const newZone = {
      //   TObject: {
      //     Product_ID: generateRandomNumber(), // Generate unique ID
      //     Plan_Name: zone.name, // Reusing structure for consistency
      //     Plan_Description: zone.description,
      //     CreatedBy: 1, // Static value for now
      //   }
      // };

      // await saveZone(newZone); // Call Zone API
      setZones([...zones, zone]);
    } catch (error) {
      console.error("Failed to save zone:", error);
    }
  };

  const handlePlanSave = async (plan) => {
    try {
      // const newPlan = {
      //   TObject: {
      //     Product_ID: generateRandomNumber(), // Generate unique ID
      //     Plan_Name: plan.name, 
      //     Plan_Description: plan.description,
      //     CreatedBy: 1,
      //   }
      // };

      // await savePlan(newPlan); // Call Plan API
      setPlans([...plans, plan]);
    } catch (error) {
      console.error("Failed to save plan:", error);
    }
  };

  // Submit Whole Form
  const handleSubmit = async (values, { resetForm }) => {
    try {
      console.log(values);
      const formData = {
        TObject: {
          ProductName: values.productName,
          Product_ShortName: values.productShortName,
          Insurer_ID: parseInt(values.insurer), // Convert insurer ID to integer
          Product_Type: "G", // Static value
          IsMultiZone: isZoneEnabled,
          IsMultiPlan: isPlanEnabled,
          Period_Available: values.periodAvailable || "2", // Default 2
          IsNoClaim_Discount: values.isNoClaimDiscount || false,
          IsCummulative_Bonus: values.isCummulativeBonus || false,
          IsFamily_Discount: values.isFamilyDiscount || false,
          IsCoPay_Discount: values.isCoPayDiscount || false,
          IsTopUp: values.isTopUp || false,
          IsIndividual: values.IsIndividual || false,
          IsFloater: values.IsFloater || false,
          IsCriticalIllness: values.IsCriticalIllness || false,
          IsDailCash: values.isDailCash || false,
          WebURL: values.webURL || "",
          Minimum_EntryAge: values.minEntryAge ? parseInt(values.minEntryAge) : 18,
          Maximum_EntryAge: values.maxEntryAge ? parseInt(values.maxEntryAge) : 35,
          CreatedBy: 1, // Static value for now
        },
      };
      await submitHealthProduct(formData);
      alert("Form submitted successfully!");
      resetForm();
      setZones([]);
      setPlans([]);
      setIsZoneEnabled(false);
      setIsPlanEnabled(false);
      setSelectedYears(1);
    } catch (error) {
      console.error("Form submission failed:", error);
    }
  };

  const handleZoneButtonClick = (value) => {
    setIsZoneEnabled(value); // Just update state
  };

  const handlePlanButtonClick = (value) => {
    setIsPlanEnabled(value); // Just update state
  };

  const handleSelectedYear = (value) => {
    setSelectedYears(value);
  }

  return (
    <div className="formContainer lg:p-4">
      <div className="flex flex-col p-4 lg:mx-5 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}
      >
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">Health Product Master</h5>

        {/* <h5 className="text-warning fw-bold">Health Product Master</h5> */}
        {/* <div className="flex flex-row justify-end items-center">
          <div className="d-flex justify-content-end gap-3">
            <button type="submit" form="healthProductForm" className="btn saveButton ">Save</button>
            <div className="flex gap-3">
              <button type="button" className="btn backButton" onClick={() => window.history.back()}>Back</button>
              <button type="button" className="btn backButton" onClick={() => window.location.reload()}>Reload</button>
            </div>
          </div>
        </div>
        <hr className="border-warning" /> */}

        {/* Formik Form */}
        <Formik
          initialValues={{
            insurer: "",
            productName: "",
            productShortName: "",
            periodAvailable: "",
            isNoClaimDiscount: false,
            isCummulativeBonus: false,
            isFamilyDiscount: false,
            isCoPayDiscount: false,
            healthProductSelection: false,
            isTopUp: false,
            isDailCash: false,
            webURL: "",
            minEntryAge: 18,
            maxEntryAge: 35
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form id="healthProductForm">
              <div className="row">

                <div
                  className="
    flex flex-col gap-2 mb-4
    lg:flex-row lg:gap-0
  "
                >
                  <label className="flex items-center gap-1 w-1/2 lg:w-auto lg:mx-2">
                    <Field type="radio" name="healthProductSelection" value="IsIndividual" className="accent-brandRed" />
                    <span>Individual</span>
                  </label>
                  <label className="flex items-center gap-1 w-1/2 lg:w-auto lg:mx-2">
                    <Field type="radio" name="healthProductSelection" value="IsFloater" className="accent-brandRed" />
                    <span>Floater</span>
                  </label>
                  <label className="flex items-center gap-1 w-1/2 lg:w-auto lg:mx-2">
                    <Field type="radio" name="healthProductSelection" value="topup" className="accent-brandRed" />
                    <span>Topup</span>
                  </label>
                  <label className="flex items-center gap-1 w-1/2 lg:w-auto lg:mx-2">
                    <Field type="radio" name="healthProductSelection" value="criticalIllness" className="accent-brandRed" />
                    <span>Critical Illness</span>
                  </label>
                </div>


                {/*<div className="col">*/}
                {/*  <label className="form-label">Insurer</label>*/}
                {/*  <Field as="select" name="insurer" className="form-select">*/}
                {/*    <option value="">Select Insurer</option>*/}
                {/*    <option value="1">Insurer 1</option>*/}
                {/*    <option value="3">Insurer 2</option>*/}
                {/*  </Field>*/}
                {/*  <ErrorMessage name="insurer" component="div" className="text-brandRed" />*/}
                {/*</div>*/}
              </div>
              <div className="flex flex-wrap ">
                <div className="w-full md:w-1/2 mb-0 sm:mb-3">
                  <InsurerDropdown name="insurer" insurerType={'L'} />
                </div>
                {/* <InsurerDropdown name="insurer" className='mt-3' /> */}
                <div className="w-full md:w-1/2 mb-0 sm:mb-3">
                  <label className="form-label mt-0 sm:mt-3">Product Name <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="productName" className="w-full px-3 py-2 custom-shadow" />
                  <ErrorMessage name="productName" component="div" className="text-brandRed" />
                </div>
                <div className="w-full md:w-1/2 mb-3">
                  <label className="form-label">Product Short Name <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="productShortName" className="w-full px-3 py-2 custom-shadow" />
                  <ErrorMessage name="productShortName" component="div" className="text-brandRed" />
                </div>
                <div className="w-full md:w-1/2 mb-3">
                  <label className="form-label mx-2">No of years</label>
                  <div className="d-flex gap-2 mx-2">
                    {[1, 2, 3].map((year) => (
                      <button
                        type="button"  // Add this line to prevent form submission
                        key={year}
                        className={`toggle-btn ${selectedYears === year ? "active" : ""}`}
                        onClick={() => handleSelectedYear(year)}
                      >
                        {year}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className=" row flex flex-row justify-between">
                {/* Zone Section */}
                <div className="col-sm-12 col-md-6 mt-3">
                  <label className="form-label">Zone</label>
                  <div>
                    <button
                      type="button"
                      className={`toggle-btn ${isZoneEnabled ? "active " : ""}`}
                      onClick={() => handleZoneButtonClick(true)}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className={`toggle-btn ${!isZoneEnabled ? "active " : ""} ms-2`}
                      onClick={() => handleZoneButtonClick(false)}
                    >
                      No
                    </button>
                  </div>
                  {isZoneEnabled && <ZoneGrid onSave={handleZoneSave} />}
                </div>

                {/* Plan Section */}
                <div className="col-sm-12 col-md-6 mt-3">
                  <label className="form-label">Plan</label>
                  <div>
                    <button type="button" className={`toggle-btn ${isPlanEnabled ? "active" : ""}`} onClick={() => handlePlanButtonClick(true)}>Yes</button>
                    <button type="button" className={`toggle-btn ${!isPlanEnabled ? "active " : ""} ms-2`} onClick={() => handlePlanButtonClick(false)}>No</button>
                  </div>
                  {isPlanEnabled && <PlanGrid onSave={handlePlanSave} />}
                </div>

              </div>

              <div className="d-flex justify-content-start gap-3 mt-5 justify-content-center">
                <button type="submit" className="saveButton d-flex" disabled={isSubmitting}>
                  <span className="m-auto p-1"><LuSave /></span>{isSubmitting ? "Saving..." : "Save"}
                </button>
                <div className="flex gap-3">
                  <button type="button" className="d-flex backButton d-flex" onClick={() => window.history.back()}> <span className="m-auto p-1"><GiCrossedBones /></span>Cancel</button>
                  {/* <button type="button" className="btn btn-outline-secondary shadow-[4px_4px_8px_rgba(0,0,0,0.3)]" onClick={() => window.location.reload()}>Reload</button> */}
                </div>
              </div>
              {/* <div className="mt-4 d-flex justify-content-center">
              <button type="submit" className="btn btn-warning " disabled={isSubmitting}>
                Save
              </button>
            </div> */}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default HealthProductMaster;